// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1nCn4","content":"styles_content__aR-iM","selectAll":"styles_selectAll__1xvSa"};